import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export enum SearchParamKeys {
    SurfaceType = "surface-type",
    Organization = "org",
    LensFolder = "lens-folder",
}

export const useSearchParams = (): URLSearchParams => {
    const searchParams = useLocation().search;

    return useMemo(() => new URLSearchParams(searchParams), [searchParams]);
};
